
<!-- <mat-form-field>
  <mat-select (selectionChange)="complexityChange($event)" [(value)]="jobComplexity">
    <mat-select-trigger><span class="trigger-complexity">{{jobComplexity}}</span></mat-select-trigger>
    <mat-option *ngFor="let complexity of complexities | async" [value]="complexity" class="mat-option job-complexity">
		<span class="complexity-text">{{complexity}}</span>
	</mat-option>
  </mat-select>
</mat-form-field> -->

<p-dropdown (onChange)="complexityChange($event.value)" [options]="statuses" [(ngModel)]="jobComplexity" placeholder="Complexity" optionLabel="title"></p-dropdown>